/**
 * PayPal utility functions
 * Provides environment-aware URLs for PayPal services
 */

/**
 * Get the PayPal mode from environment variables
 * @returns 'sandbox' or 'live'
 */
export const getPayPalMode = (): 'sandbox' | 'live' => {
  const mode = process.env.REACT_APP_PAYPAL_MODE || 'sandbox';
  return mode === 'live' ? 'live' : 'sandbox';
};

/**
 * Check if running in sandbox mode
 */
export const isSandboxMode = (): boolean => {
  return getPayPalMode() === 'sandbox';
};

/**
 * Get the PayPal subscription management URL based on environment
 * @returns URL to manage PayPal subscriptions
 */
export const getPayPalSubscriptionManagementUrl = (): string => {
  return isSandboxMode()
    ? 'https://www.sandbox.paypal.com/myaccount/autopay/'
    : 'https://www.paypal.com/myaccount/autopay/';
};

/**
 * Get the PayPal home URL based on environment
 * @returns URL to PayPal home
 */
export const getPayPalHomeUrl = (): string => {
  return isSandboxMode()
    ? 'https://www.sandbox.paypal.com/'
    : 'https://www.paypal.com/';
};

/**
 * Get the PayPal account URL based on environment
 * @returns URL to PayPal account page
 */
export const getPayPalAccountUrl = (): string => {
  return isSandboxMode()
    ? 'https://www.sandbox.paypal.com/myaccount/summary'
    : 'https://www.paypal.com/myaccount/summary';
};
